import { CandidateStatus } from 'generated-graphql/types';

export const candidateStatusLabelMap = {
  [CandidateStatus.ShortListed]: 'Shortlisted',
  [CandidateStatus.NotProgressing]: 'Not progressing',
  [CandidateStatus.Rejected]: 'Rejected',
  [CandidateStatus.Review]: 'Review',
  [CandidateStatus.InterviewStage_1]: '1st interview stage',
  [CandidateStatus.InterviewStage_2]: '2nd interview stage',
  [CandidateStatus.Offer]: 'Offer',
  [CandidateStatus.Progressing]: 'Progressing'
};
